import { t } from "i18next";

import { SimpleResult } from "../dto";
import { Api, getCompanyId, Log } from "../helpers";
import {
  ICourseDto,
  IRecountStationsResultDto,
  IRydeProcess,
  RecountCourseStationsCriteriaDto,
} from "../models";

export class CoursesApi {
  /**
   * Composes an unsaved course out of stations picked in bulk on the stations page. The server applies the
   * fixed defaults, names the draft after the id the course will get and builds the route once.
   */
  static async buildDraftFromStations(
    stationIds: number[],
  ): Promise<SimpleResult<Partial<ICourseDto>> | undefined> {
    const response = await Api.post<SimpleResult<Partial<ICourseDto>>>(
      `/api/v1/core/c/${getCompanyId()}/courses/draft-from-stations`,
      { stationIds },
    );

    return response?.data;
  }

  static async recountStationInfo(
    criteria: RecountCourseStationsCriteriaDto,
  ): Promise<IRecountStationsResultDto | undefined> {
    const { stations } = criteria;

    if (!stations?.length) {
      Log.warnAndToast(t("errors.invalidDataForRecountNoStationOfDate"));
      return undefined;
    }

    const response = await Api.post<IRecountStationsResultDto>(
      `/api/v1/core/c/${getCompanyId()}/courses/recount-stations`,
      criteria,
    );

    return response?.data;
  }

  static async deepRecalculate(
    criteria: RecountCourseStationsCriteriaDto,
  ): Promise<IRecountStationsResultDto | undefined> {
    const { stations } = criteria;

    if (!stations?.length) {
      Log.warnAndToast(t("errors.invalidDataForRecountNoStationOfDate"));
      return undefined;
    }

    const response = await Api.post<IRecountStationsResultDto>(
      `/api/v1/core/c/${getCompanyId()}/courses/deep-recalculate`,
      criteria,
    );

    return response?.data;
  }

  static async bulkDeepRecalculateCourses(payload: {
    ids: number[];
  }): Promise<SimpleResult<IRydeProcess> | undefined> {
    const response = await Api.patch<SimpleResult<IRydeProcess>>(
      `/api/v1/core/c/${getCompanyId()}/courses/bulk/deep-recalculate`,
      payload,
    );

    return response?.data;
  }
}
